import { createFileRoute } from '@tanstack/react-router'

import PagePlaygroundEnrichment from '../pages/PagePlaygroundEnrichment'

export const Route = createFileRoute('/playground/enrichment')({
  component: PagePlaygroundEnrichment
})
